import Modal from "react-bootstrap/Modal";
import {
  ErrorMessage,
  LoadingData,
  MainButton,
  CancelButtonOutline,
} from "../../ui";

export const CancelAssessmentModal = ({
  isOpen,
  setIsOpen,
  onSubmit,
  propsForm,
}) => {
  // Datos del hook ----------------------------------------//
  const { isLoading } = propsForm;

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <Modal
      show={isOpen}
      onHide={() => {
        setIsOpen(false);
      }}
      centered
      size="md"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title">Reagendar valoración</h5>
      </Modal.Header>
      <Modal.Body>
        <div className="vstack gap-3">
          <p className="mb-0">
            Para reagendar tu sesión de valoración primero debes cancelar tu
            sesión actual. Recuerda que solo podrás hacerlo con al menos 24
            horas de anticipación.
          </p>
          {/* Mensajes */}
          {isLoading && <LoadingData />}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <CancelButtonOutline
          type="button"
          onClick={() => {
            setIsOpen(false);
          }}
        >
          Cancelar
        </CancelButtonOutline>
        <MainButton
          type="button"
          onClick={() => {
            onSubmit();
          }}
          disabled={isLoading}
        >
          Aceptar
        </MainButton>
      </Modal.Footer>
    </Modal>
  );
};
